/* eslint-disable max-lines-per-function */
import { useEffect, useReducer } from 'react';

import { DateMenu } from './date-menu';
import { getNextMonth, getPreviousMonth } from './date-picker-utilities';
import {
  CalendarMenuType,
  DatePickerAction,
  DatePickerActionType,
  DatePickerCalendarProps,
  DatePickerState,
} from './date-picker.types';
import { MonthMenu } from './month-menu';
import { YearMenu } from './year-menu';

const datePickerReducer = (state: DatePickerState, action: DatePickerAction): DatePickerState => {
  switch (action.type) {
    case DatePickerActionType.SELECT_DATE: {
      return {
        ...state,
        selectionStart: action.payload[0],
        selectionEnd: action.payload[1],
      };
    }
    case DatePickerActionType.PREV_MONTH: {
      const [newYear, newMonth] = getPreviousMonth(state.year, state.month);
      return {
        ...state,
        year: newYear,
        month: newMonth,
      };
    }
    case DatePickerActionType.NEXT_MONTH: {
      const [newYear, newMonth] = getNextMonth(state.year, state.month);
      return {
        ...state,
        year: newYear,
        month: newMonth,
      };
    }
    case DatePickerActionType.PREV_YEAR: {
      return {
        ...state,
        year: state.year - 1,
      };
    }
    case DatePickerActionType.NEXT_YEAR: {
      return {
        ...state,
        year: state.year + 1,
      };
    }
    case DatePickerActionType.SET_MENU: {
      return {
        ...state,
        previousMenu: state.menu,
        menu: action.menu,
      };
    }
    case DatePickerActionType.SET_MONTH: {
      return {
        ...state,
        menu: CalendarMenuType.DATE_MENU,
        previousMenu: state.menu,
        month: action.month,
      };
    }
    case DatePickerActionType.SET_YEAR: {
      return {
        ...state,
        menu: state.previousMenu,
        year: action.year,
      };
    }
  }
  return state;
};

export const DatePickerCalendar = (props: DatePickerCalendarProps) => {
  const {
    defaultYear,
    defaultMonth,
    rangeSelection: isRangeSelection = false,
    selectionStart: defaultSelectionStart,
    selectionEnd: defaultSelectionEnd,
    onChange,
    isDisabledDate,
  } = props;
  const [state, dispatch] = useReducer(
    datePickerReducer,
    {
      year: defaultYear ?? (defaultSelectionStart ?? new Date()).getFullYear(),
      month: defaultMonth ?? (defaultSelectionStart ?? new Date()).getMonth(),
      selectionStart: defaultSelectionStart,
      selectionEnd: defaultSelectionEnd,
      isRangeSelection,
      menu: CalendarMenuType.DATE_MENU,
    } as DatePickerState,
    (state) => state
  );

  useEffect(() => {
    dispatch({
      type: DatePickerActionType.SELECT_DATE,
      payload: [defaultSelectionStart, defaultSelectionEnd],
    });
  }, [defaultSelectionStart, defaultSelectionEnd]);

  switch (state.menu) {
    case CalendarMenuType.MONTH_MENU: {
      return <MonthMenu state={state} dispatch={dispatch} />;
    }
    case CalendarMenuType.YEAR_MENU: {
      return <YearMenu state={state} dispatch={dispatch} />;
    }
    default: {
      return <DateMenu state={state} dispatch={dispatch} onChange={onChange} isDisabledDate={isDisabledDate} />;
    }
  }
};
